export enum EncounterType {
  ECHO = "Echo",
  ESTABLISHED_PATIENT = "Established Patient",
  HOSPITAL_PROCEDURE_30 = "Hospital Procedure 30",
  MIGRATED = "Migrated",
  NEW_PATIENT = "New Patient",
  TEL = "TEL",
  WEB = "WEB",
}

export enum EncounterStatus {
  ARRIVED = "arrived",
  CANCELLED = "cancelled",
  FINISHED = "finished",
  PLANNED = "planned",
  UNKNOWN = "unknown",
}

export interface FilterEncounterOptions {
  excludedTypes?: EncounterType[];
  excludedStatuses?: EncounterStatus[];
  excludeNoType?: boolean;
}

export const DEFAULT_ENCOUNTER_FILTER_OPTIONS: FilterEncounterOptions = {
  excludedTypes: [EncounterType.TEL, EncounterType.MIGRATED],
  excludedStatuses: [EncounterStatus.CANCELLED],
};
